import React from 'react';
import intl from 'react-intl-universal';
import * as R from 'ramda';
import { MenuItem } from '@blueprintjs/core';
import { FMultiSelect } from '@/components/Forms';
import withDialogActions from '@/containers/Dialog/withDialogActions';
import { DialogsName } from '@/constants/dialogs';

// Create new item renderer.
const createNewItemRenderer = (
  query: string,
  active: boolean,
  handleClick: React.MouseEventHandler<HTMLElement>,
) => {
  return (
    <MenuItem
      icon="add"
      text={intl.get('list.create', { value: `"${query}"` })}
      active={active}
      onClick={handleClick}
    />
  );
};

// Create new item from the given query string.
const createNewItemFromQuery = (name: string) => ({ name });

interface ItemsMultiSelectRootProps {
  openDialog: (name: DialogsName, payload?: any) => void;
  closeDialog: (name: DialogsName) => void;
  allowCreate?: boolean;
  [key: string]: any;
}

/**
 * Items multi-select.
 */
function ItemsMultiSelectRoot({
  // #withDialogAction
  openDialog,
  closeDialog,

  // #props
  allowCreate,
  ...multiSelectProps
}: ItemsMultiSelectRootProps) {
  // Maybe inject new item props to select component.
  const maybeCreateNewItemRenderer = allowCreate
    ? createNewItemRenderer
    : undefined;
  const maybeCreateNewItemFromQuery = allowCreate
    ? createNewItemFromQuery
    : undefined;

  // Handles the create item click.
  const handleCreateItemClick = () => {
    openDialog(DialogsName.AccountForm);
  };

  return (
    <FMultiSelect
      valueAccessor={'id'}
      textAccessor={'name'}
      labelAccessor={'code'}
      tagAccessor={'name'}
      fill={true}
      popoverProps={{ minimal: true }}
      resetOnSelect={true}
      createNewItemRenderer={maybeCreateNewItemRenderer}
      createNewItemFromQuery={maybeCreateNewItemFromQuery}
      onCreateItemSelect={handleCreateItemClick}
      {...multiSelectProps}
    />
  );
}

export const ItemsMultiSelect =
  R.compose(withDialogActions)(ItemsMultiSelectRoot);
